export const GET_QUESTIONS_ERROR = "redux_store:feedbacks.error.get_questions";
export const UPDATE_QUESTION_ERROR = "redux_store:feedbacks.error.update_question";
export const ADD_QUESTION_ERROR = "redux_store:feedbacks.error.add_question";
export const DELETE_QUESTION_ERROR = "redux_store:feedbacks.error.delete_question";

export const GET_QUESTION_TYPES_ERROR = "redux_store:feedbacks.error.get_question_types";
export const GET_SURVEYS_ERROR = "redux_store:feedbacks.error.get_surveys";
export const GET_FEEDBACKS_ERROR = "redux_store:feedbacks.error.get_feedbacks";
export const GET_FEEDBACKS_STATS_ERROR = "redux_store:feedbacks.error.get_feedbacks_stats";
export const UPDATE_FEEDBACKS_ERROR = "redux_store:feedbacks.error.update_feedbacks";
export const GET_NEW_FEEDBACKS_ERROR = "redux_store:feedbacks.error.get_new_feedbacks";



// WEBPACK FOOTER //
// ./src/errors/feedbacks.js